import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-client',
  templateUrl: './our-client.component.html',
  styleUrls: ['./our-client.component.css'],
})
export class OurClientComponent implements OnInit {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  groupedServices: any = [];
  constructor() {}

  ngOnInit(): void {
    this.updateGroupedServices();
  }

  groupArray<T>(arr: T[], chunkSize: number): T[][] {
    const groups: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
  }

  updateGroupedServices() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 8);
    } else if (screenWidth >= 576 && screenWidth < 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 6);
    } else if (screenWidth < 576) {
      this.groupedServices = this.groupArray(this.data.details.services, 4);
    }
  }
  openLink(link: string) {
    if (link) {
      window.open(link, '_blank');
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateGroupedServices();
  }
}
